/* eslint-disable prettier/prettier */
import { CollapsibleSection } from '../file/CollapsibleSection';
import { ComparisonTable } from './ComparisonTable';
import { emojiIconMap } from '../../utils/emojiIconMap';

interface ProportionalSectionsComparisonProps {
  sections: any[];
  showDifferences?: boolean;
}

export const ProportionalSectionsComparison = ({
  sections,
  showDifferences,
}: ProportionalSectionsComparisonProps) => {
  if (!Array.isArray(sections)) return null;

  const sectionHasDifferences = (section: any) => {
    return Object.entries(section).some(([key, value]) => {
      if (key === 'type') return false;
      return (
        typeof value === 'object' &&
        value !== null &&
        'isDifferent' in value &&
        (value as any).isDifferent === true
      );
    });
  };

  const filteredSections = showDifferences ? sections.filter(sectionHasDifferences) : sections;

  if (filteredSections.length === 0) return null;

  return (
    <div className="flex flex-col gap-4">
      {filteredSections.map((section, index) => {
        const type = section.type;
        const title = `${type === 'QUOTA_SHARE' ? 'QUOTA SHARE' : 'SURPLUS'} - Proportional`;

        const formattedData: Record<string, { left: any; right: any; isDifferent: boolean }> = {};

        Object.entries(section).forEach(([key, value]) => {
          if (key === 'type') return;

          const typedValue = value as {
            left: any;
            right: any;
            isDifferent: boolean;
          };

          formattedData[key] = {
            left: typedValue.left,
            right: typedValue.right,
            isDifferent: typedValue.isDifferent,
          };
        });

        let fieldLabels: Record<string, string> = {
          commissionRate: 'Commission Rate',
          commissionType: 'Commission Type',
          lossPortfolioEntry: 'Loss Portfolio Entry',
          lossPortfolioWithdrawal: 'Loss Portfolio Withdrawal',
          overrideRate: 'Override Rate',
          premiumPortfolioEntry: 'Premium Portfolio Entry',
          premiumPortfolioWithdrawal: 'Premium Portfolio Withdrawal',
          profitCommissionRate: 'Profit Commission Rate',
          EPI: 'EPI',
          cdtCessionRate: 'Cdt Cession Rate',
          cdtRetentionRate: 'Cdt Retention Rate',
        };

        if (type === 'SURPLUS') {
          fieldLabels = {
            ...fieldLabels,
            numberOfLines: 'Number of Lines',
            retention: 'Retention',
            surplus: 'Surplus',
            minimumDepositInst: 'Minimum Deposit (Instalment)',
            minimumAmountInst: 'Minimum Amount (Instalment)',
          };
        }

        return (
          <CollapsibleSection
            key={index}
            title={title}
            icon={
              emojiIconMap[
                type === 'QUOTA_SHARE' ? 'QUOTA SHARE - Proportional' : 'SURPLUS - Proportional'
              ]
            }
          >
            <ComparisonTable
              data={formattedData}
              fieldLabels={fieldLabels}
              showDifferences={showDifferences}
            />
          </CollapsibleSection>
        );
      })}
    </div>
  );
};
